import $ from 'jquery'
import { elementExists } from './shared'
import { selectors } from './selectors'

const OPEN_CLASS = 'is-open'

// ---------- Desktop dropdowns (click to open, one at a time) ----------

const closeAllDropdowns = () => {
    $(selectors.header.navItem).removeClass(OPEN_CLASS).find(selectors.header.navTrigger).attr('aria-expanded', 'false')
}

const initDesktopDropdowns = () => {
    const $items = $(selectors.header.navItem)
    if (!elementExists($items)) return

    $items.each((index, item) => {
        const $item = $(item)
        const $trigger = $item.find(selectors.header.navTrigger).first()
        if (!elementExists($trigger)) return

        $trigger.on('click', (event) => {
            event.stopPropagation()
            const willOpen = !$item.hasClass(OPEN_CLASS)
            closeAllDropdowns()
            $item.toggleClass(OPEN_CLASS, willOpen)
            $trigger.attr('aria-expanded', String(willOpen))
        })
    })

    $(document).on('click', (event) => {
        if (!$(event.target).closest(selectors.header.navItem).length) closeAllDropdowns()
    })
    $(document).on('keydown', (event) => {
        if (event.key === 'Escape') closeAllDropdowns()
    })
}

// ---------- Mobile hamburger drawer ----------

const initBurger = () => {
    const $burger = $(selectors.header.burger)
    const $drawer = $(selectors.header.drawer)
    if (!elementExists($burger) || !elementExists($drawer)) return

    $burger.on('click', () => {
        const isOpen = $drawer.toggleClass(OPEN_CLASS).hasClass(OPEN_CLASS)
        $burger.toggleClass(OPEN_CLASS, isOpen).attr('aria-expanded', String(isOpen))
        $('body').toggleClass('has-drawer-open', isOpen)
    })

    $(window).on('resize', () => {
        $drawer.removeClass(OPEN_CLASS)
        $burger.removeClass(OPEN_CLASS).attr('aria-expanded', 'false')
        $('body').removeClass('has-drawer-open')
    })
}

// ---------- Mobile drawer accordions ----------

const initDrawerAccordions = () => {
    const $toggles = $(selectors.header.drawerToggle)
    if (!elementExists($toggles)) return

    $toggles.on('click', (event) => {
        const $row = $(event.currentTarget)
        const $sub = $('#' + $row.attr('data-drawer-toggle'))
        const willOpen = !$sub.hasClass(OPEN_CLASS)
        $sub.toggleClass(OPEN_CLASS, willOpen)
        $row.toggleClass(OPEN_CLASS, willOpen).attr('aria-expanded', String(willOpen))
    })
}

export function initHeaderNav() {
    initDesktopDropdowns()
    initBurger()
    initDrawerAccordions()
}
